import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_CRUDLIST} from './_Action'

export const CATEGORY = 'category'
export const CATEGORIES = 'categories'

const _CATEGORIES = _CRUDLIST(CATEGORIES)

export const fetchCategories = () => (dispatch, getState: () => RootState) => {
    return dispatch({
      [_CALL_API]: {
        types: [ _CATEGORIES.GET.REQUEST, _CATEGORIES.GET.SUCCESS, _CATEGORIES.GET.FAILURE ],
        route: route.category.fetch()
      }
    })
  };
  




// WEBPACK FOOTER //
// ./src/core/redux/action/categoriesAction.ts